<template>
  <div class="flex flex-col items-center w-full privacy mb-128">
    <div
      class="relative w-full max-w-[620px] my-24 lg:my-128 px-20 pt-128 z-20 lg:text-16"
    >
      <h3>{{ $t("privacy.title") }}</h3>

      <div>
        {{ $t("privacy.description") }}
      </div>

      <h4>{{ $t("privacy.definitions.title") }}</h4>
      <div v-for="text in $tm('privacy.definitions.text')" v-html="text"></div>

      <h4>{{ $t("privacy.types.title") }}</h4>
      <div v-html="$t('privacy.types.description')"></div>
      <div>{{ $t("privacy.types.email") }}</div>

      <div class="flex gap-4">
        <div>2.</div>

        <div class="flex flex-col">
          <div class="!mt-0">{{ $t("privacy.types.cookies") }}</div>
          <div v-for="text in $tm('privacy.types.text')" v-html="text"></div>

          <ul>
            <li
              v-for="text in $tm('privacy.types.examples')"
              v-html="text"
            ></li>
          </ul>
        </div>
      </div>

      <h4>{{ $t("privacy.usage.title") }}</h4>
      <div>{{ $t("privacy.usage.description") }}</div>

      <ol>
        <li v-for="text in $tm('privacy.usage.examples')" v-html="text"></li>
      </ol>

      <strong>{{ $t("privacy.usage.tracking.title") }}</strong>
      <div>{{ $t("privacy.usage.tracking.description") }}</div>
      <SharedLink url="https://plausible.io/about" class="underline">{{
        $t("privacy.usage.tracking.more")
      }}</SharedLink>

      <h3 class="mt-80">{{ $t("privacy.cookies.title") }}</h3>
      <div class="!mb-20">{{ $t("privacy.cookies.description") }}</div>

      <UiButton @click="reselect()"> {{ $t("privacy.cookies.cta") }} </UiButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
const essentialCookie = useCookie("essential_cookies_accepted");
function reselect() {
  essentialCookie.value = undefined;
}
</script>

<style lang="scss" scoped>
.privacy {
  h4 {
    @apply mt-64;
  }

  div,
  strong {
    @apply my-8;
  }

  li {
    list-style: disc;
    @apply ml-16 my-8;
  }
}
</style>
